import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { PositionsBaseDataFieldsConfig } from "../position/components/positions-base-data-fields";
import { omniPositionsBaseDataFieldsConfig } from "./omni-positions-base-data-fields-config";
import { shsPositionsBaseDataFieldsConfig } from "./shs-positions-base-data-fields-config";
import { wrhPositionsBaseDataFieldsConfig } from "./wrh-positions-base-data-fields-config";

/**
 * positionsBaseDataFieldsConfigFor returns the configuration of the
 * {@link PositionsBaseDataFields} of the positions base data of the service
 * kind: its own where the kind narrows the omni defaults, otherwise
 * {@link omniPositionsBaseDataFieldsConfig}. Mirrors
 * `servicekindrules.Positions`,
 * backend/core/omni/domain/servicekindrules/positions.go.
 */
export function positionsBaseDataFieldsConfigFor(
  kind: string,
): PositionsBaseDataFieldsConfig {
  switch (kind) {
    case GSMServiceKind.SHS:
      return shsPositionsBaseDataFieldsConfig;
    case GSMServiceKind.WRH:
      return wrhPositionsBaseDataFieldsConfig;
    default:
      return omniPositionsBaseDataFieldsConfig;
  }
}
